import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import MunicipalityEditForm from './../../elements/municipalities/form';
import Loading from "../../elements/loading";
import MunicipalityAdd from './../../elements/municipalities/widget/municipality_add';

class MununicipalityEdit extends Component {
	render (){
		const { entities, municipalities, status, modalities } = this.props;
		return(
			entities.isFetching || municipalities.isFetching || status.isFetching || modalities.isFetching ?  <Loading/>:<MunicipalityEditForm {...this.props}/>
		);
	}

	componentWillMount() {
		this.props.fetchEntities();
		this.props.fetchMunicipality(this.props.match.params.id);
		this.props.fetchStatus(1);
		this.props.fetchModalities();
	}
}
//export default BaseLayout(MununicipalityEdit, {title: `Editar Municipio`, subnav: {icon: 'fa-map-marker', name: 'Administración', actions: {url: '/municipios/crear', name: 'Agregar Municipio'}}});
export default BaseLayout(MununicipalityEdit, {
	title: `Editar Municipio`,
	subnav: {
		icon: 'fa-map-marker',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <MunicipalityAdd />
			}
		]
	}
});




// WEBPACK FOOTER //
// ./src/layouts/municipalities/edit.jsx